interface StorageOptions {
  unit?: 'bytes' | 'KB' | 'MB' | 'GB';
  precision?: number;
}

export const format = {
  phone: (value?: string) => {
    if (!value) return value;

    const digits = value.replaceAll(/\D/g, '');

    if (digits.length <= 2) return digits;

    // 서울 지역번호 (02)
    if (digits.startsWith('02')) {
      if (digits.length <= 6) return digits.replace(/(\d{2})(\d+)/, '$1-$2');

      return digits.replace(/(\d{2})(\d{4})(\d+)/, '$1-$2-$3');
    }

    // 휴대폰 번호
    if (/^010/.test(digits)) {
      if (digits.length <= 7) return digits.replace(/(\d{3})(\d+)/, '$1-$2');

      return digits.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
    }

    // 전국대표번호 (1522, 1533, 1544, 1566, 1577, 1588, 1599, 1600, 1644, 1660, 1661, 1666, 1668, 1670, 1688, 1800, 1811, 1833, 1855, 1866, 1877, 1899)
    if (
      /^(1522|1533|1544|1566|1577|1588|1599|1600|1644|1660|1661|1666|1668|1670|1688|1800|1811|1833|1855|1866|1877|1899)/.test(
        digits,
      )
    ) {
      if (digits.length <= 4) return digits;

      return digits.replace(/(\d{4})(\d+)/, '$1-$2');
    }

    // 기타 지역번호 (3자리)
    if (digits.length <= 3) return digits;
    if (digits.length <= 7) return digits.replace(/(\d{3})(\d+)/, '$1-$2');
    if (digits.length <= 10)
      return digits.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');

    return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  },
  storage: (bytes = 0, options?: StorageOptions) => {
    const kiloBytes = bytes / 1024;
    const megaBytes = bytes / 1048576; // 1024 * 1024
    const gigaBytes = bytes / 1073741824; // 1024 * 1024 * 1024

    const { unit = 'MB', precision = 2 } = options ?? {};

    switch (unit) {
      case 'bytes':
        return `${bytes} bytes`;
      case 'KB':
        return `${kiloBytes.toFixed(precision)}KB`;
      case 'MB':
        return `${megaBytes.toFixed(precision)}MB`;
      case 'GB':
        return `${gigaBytes.toFixed(precision)}GB`;
      default:
        throw new Error('정의하지 않은 단위 유형이에요.');
    }
  },
  number: (num: number) => {
    const units = ['경', '조', '억', '만', ''];
    let remainder = num;
    let result = '';

    for (let i = 0; i < units.length; i++) {
      const unitValue = Math.pow(10000, units.length - 1 - i);
      const currentUnit = Math.floor(remainder / unitValue);
      remainder %= unitValue;

      if (currentUnit > 0) {
        result += currentUnit.toLocaleString() + units[i] + ' ';
      }
    }

    return result.trim() || '0';
  },
};
